"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _balloon = require("@alicd/next/lib/balloon");

var _balloon2 = _interopRequireDefault(_balloon);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CellWithCopyBalloon = function (_React$Component) {
    (0, _inherits3.default)(CellWithCopyBalloon, _React$Component);

    function CellWithCopyBalloon(props) {
        (0, _classCallCheck3.default)(this, CellWithCopyBalloon);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CellWithCopyBalloon.__proto__ || (0, _getPrototypeOf2.default)(CellWithCopyBalloon)).call(this, props));

        _this.state = {
            visible: false
        };

        _this.handleClick = _this.handleClick.bind(_this);
        _this.onVisibleChange = _this.onVisibleChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(CellWithCopyBalloon, [{
        key: "handleClick",
        value: function handleClick() {
            this.setState({ visible: false });
            this.props.onClick && this.props.onClick();
        }
    }, {
        key: "onMouseEnter",
        value: function onMouseEnter() {
            this.setState({ visible: true });
        }
    }, {
        key: "onVisibleChange",
        value: function onVisibleChange(visible) {
            this.setState({ visible: visible });
        }
    }, {
        key: "render",
        value: function render() {
            // 11/12/2017: forced to switch to the semantically-incorrect <span> ...
            //  because the style of text Button sucks now and @yabing.zyb thinks <span> is "better"
            //  though some style override is necessary for either case anyway
            return _react2.default.createElement(
                _balloon2.default,
                {
                    className: "cn-table-balloon-copy",
                    trigger: _react2.default.createElement(
                        "span",
                        null,
                        this.props.trigger
                    ),
                    align: "t",
                    closable: false,
                    visible: this.state.visible,
                    onVisibleChange: this.onVisibleChange
                },
                _react2.default.createElement(
                    "span",
                    {
                        onClick: this.handleClick
                    },
                    this.props.text
                )
            );
        }
    }]);
    return CellWithCopyBalloon;
}(_react2.default.Component);

CellWithCopyBalloon.propTypes = {
    text: _propTypes2.default.string,
    trigger: _propTypes2.default.element,
    onClick: _propTypes2.default.func
};
exports.default = CellWithCopyBalloon;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table@0.0.78@@alicd/crui-table/lib/CellWithCopyBalloon.js
// module id = 693
// module chunks = 0